import { openExternal } from 'global/viewSettings/helpers/settingsLinks';
import { getFbConfig } from 'project/appConfiguration';
import React, { useCallback } from 'react'

export const _triggerUrlTypes = {
  auth: 'auth',
  cloudArtifactsConsole: 'cloudArtifactsConsole',
  cloudDataConsole: 'cloudDataConsole',
  cloudStorageConsole: 'cloudStorageConsole',
  credentials: 'credentials',
  database: 'database',
  databaseFunctions: 'databaseFunctions',
  databaseSettings: 'databaseSettings',
  databaseStorage: 'databaseStorage',
  development: 'development',
  emailConfirmation: 'emailConfirmation',
  googleAnalytics: 'googleAnalytics',
  production: 'production',
  realtimeDatabase: 'realtimeDatabase',
  serviceAccount: 'serviceAccount',
  serviceApiAccount: 'serviceApiAccount',
  signInDemo: 'signInDemo',
}

export const useExternal = ({ pathViews, productionSettings }) => {

  const handleOpenSettingsItem = useCallback(({ triggerUrl, nonLandingView }) => {

    switch (triggerUrl) {
      case _triggerUrlTypes.emailConfirmation:
        if (pathViews.events) {
          const dummyPath = 'http://localhost:3000/?apiKey=AIzaSyDHbf1FjfK5gM89jIv6ZcP9_9QY-cX2ufc&oobCode=XgX0Ao1Nuqnn88PeLUc4_zvQ6D8JfHZ8OH8NEgPnrYYAAAGM5NSVcw&emailSignInConfirmation=true&testing=true&mode=signIn&lang=en#'
          const emailPath = '/clients/' + pathViews.clients + '/events/' + pathViews.events + '/landing'
          const fullPath = dummyPath + emailPath
          window.open(fullPath, '_blank')
        }
        break;

      case _triggerUrlTypes.signInDemo:
        console.log('OPEN SIGN IN DEMO')
        break;

      case _triggerUrlTypes.development:
        let suffix_dev;
        if (pathViews.events) {
          suffix_dev = 'clients/' + pathViews.clients + '/events/' + pathViews.events
        } else if (pathViews.clients) {
          suffix_dev = 'clients/' + pathViews.clients
        }
        window.open(_appUrlPaths.dev + suffix_dev, '_blank')
        break;

      case _triggerUrlTypes.production:
        const { clientKey, eventKey } = productionSettings ?? {}
        let suffix_prod;
        if (eventKey) {
          suffix_prod = 'clients/' + clientKey + '/events/' + eventKey
        } else if (clientKey) {
          suffix_prod = 'clients/' + clientKey
        }
        window.open(_appUrlPaths.prod + suffix_prod, '_blank')
        break;
      case _triggerUrlTypes.auth:
        openExternal.firebaseAuth()
        break;
      case _triggerUrlTypes.database:
        openExternal.db(pathViews)
        break;
      case _triggerUrlTypes.realtimeDatabase:
        openExternal.realtimeDb(pathViews)
        break;
      case _triggerUrlTypes.databaseSettings:
        openExternal.settingsDb(pathViews, nonLandingView)
        break;
      case _triggerUrlTypes.credentials:
        openExternal.credentials()
        break;
      case _triggerUrlTypes.databaseFunctions:
        openExternal.functions()
        break;
      case _triggerUrlTypes.databaseStorage:
        openExternal.db(pathViews, true)
        break;
      case _triggerUrlTypes.cloudArtifactsConsole:
        openExternal.cloudArtifactsConsole(pathViews)
        break;
      case _triggerUrlTypes.cloudStorageConsole:
        openExternal.cloudStorageConsole(pathViews)
        break;
      case _triggerUrlTypes.cloudDataConsole:
        openExternal.cloudDataConsole(pathViews)
        break;
      case _triggerUrlTypes.googleAnalytics:
        openExternal.googleAnalyticsLink(pathViews)
        break;
      case _triggerUrlTypes.serviceAccount:
      case _triggerUrlTypes.serviceApiAccount:
        const trueConfig = getFbConfig()
        const { projectId } = trueConfig
        const openApi = triggerUrl === _triggerUrlTypes.serviceApiAccount
        let url = openExternal.serviceLink(projectId, openApi)
        window.open(url, '_blank')
        break;
      default:
      // nothing
    }
  }, []);

  return {
    handleOpenSettingsItem
  }

}
